"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATE_FIELD_CONFIG_ID = exports.HOUSEHOLD_INCOME_CONFIG_ID = exports.PERSONAL_INCOME_CONFIG_ID = exports.WORKING_REMOTE_FIELD_CONFIG_ID = exports.BASE_APP_ID = void 0;
exports.BASE_APP_ID = '000000000000000000000000';
exports.WORKING_REMOTE_FIELD_CONFIG_ID = '613a0db5ec74722e74fb9b16';
exports.PERSONAL_INCOME_CONFIG_ID = '613a0d3cec74722e74fb9b14';
exports.HOUSEHOLD_INCOME_CONFIG_ID = '613a0a6bec74722e74fb9b10';
exports.STATE_FIELD_CONFIG_ID = '6137cd3dec74722e74fb9b07';
